import React from 'react';
import GeoMetricInfoIcon from './GeoMetricInfoIcon';

/** Panel title with optional metric definition tooltip. */
export default function GeoMetricTitle({
  children,
  metricKey,
  tooltip,
  className = 'report-card-title geo-metric-title',
  as: Tag = 'h3',
}) {
  return (
    <Tag className={className}>
      <span className="geo-metric-title__label">{children}</span>
      <GeoMetricInfoIcon metricKey={metricKey} text={tooltip} title={typeof children === 'string' ? children : undefined} />
    </Tag>
  );
}
